<template>
    <va-create-layout>
        <auction-category-form
            :item="item"
            :title="title"
        ></auction-category-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"]
};
</script>
